var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tiny-block-component"
  }, [_vm.tooltip ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-card', _vm._g(_vm._b({
          staticClass: "tiny-block-card",
          "class": _vm.cardClasses,
          attrs: {
            "elevation": _vm.elevation
          },
          on: {
            "click": _vm.handleClick
          }
        }, 'v-card', attrs, false), on), [_vm._t("default")], 2)];
      }
    }], null, true)
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTooltip)
    }
  })]) : _c('v-card', {
    staticClass: "tiny-block-card",
    "class": _vm.cardClasses,
    attrs: {
      "elevation": _vm.elevation
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }